class DragScroll {
  constructor(element) {
    this.scroller = element;
    this.isDown = false;
    this.dragged = false;
    this.startX = 0;
    this.scrollLeft = 0;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onDragStart = this.onDragStart.bind(this);
    this.updateScrollbar = this.updateScrollbar.bind(this);
    this.scrollbar = element.parentElement?.querySelector(
      '.collection-list-scrollbar, .product-media-scrollbar'
    );
    this.thumb = this.scrollbar?.querySelector(
      '.collection-list-scrollbar__thumb, .product-media-scrollbar__thumb'
    );

    this.scroller.querySelectorAll('a, img').forEach((node) => {
      node.setAttribute('draggable', 'false');
    });

    this.scroller.addEventListener('dragstart', this.onDragStart, true);
    this.scroller.addEventListener('pointerdown', this.onPointerDown);
    this.scroller.addEventListener('click', this.onClick, true);
    this.scroller.addEventListener('scroll', this.updateScrollbar, { passive: true });
    window.addEventListener('resize', this.updateScrollbar);

    this.updateScrollbar();
  }

  canScroll() {
    return this.scroller.scrollWidth > this.scroller.clientWidth + 4;
  }

  updateScrollbar() {
    if (!this.scrollbar || !this.thumb) return;

    const overflow = this.scroller.scrollWidth - this.scroller.clientWidth;
    if (overflow <= 4) {
      this.scrollbar.hidden = true;
      return;
    }

    this.scrollbar.hidden = false;
    const track = this.scrollbar.clientWidth;
    const thumbWidth = Math.max(24, (this.scroller.clientWidth / this.scroller.scrollWidth) * track);
    const maxOffset = Math.max(0, track - thumbWidth);
    const offset = (this.scroller.scrollLeft / overflow) * maxOffset;
    this.thumb.style.width = `${thumbWidth}px`;
    this.thumb.style.transform = `translateX(${offset}px)`;
  }

  onDragStart(event) {
    event.preventDefault();
  }

  onPointerDown(event) {
    if (event.pointerType === 'touch') return;
    if (event.button !== 0) return;
    if (!this.canScroll()) return;

    this.isDown = true;
    this.dragged = false;
    this.startX = event.clientX;
    this.scrollLeft = this.scroller.scrollLeft;

    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);
    window.addEventListener('pointercancel', this.onPointerUp);
  }

  onPointerMove(event) {
    if (!this.isDown) return;

    const dx = event.clientX - this.startX;
    if (!this.dragged) {
      if (Math.abs(dx) < 8) return;
      this.dragged = true;
      this.scroller.classList.add('is-dragging');
    }

    this.scroller.scrollLeft = this.scrollLeft - dx;
    event.preventDefault();
  }

  onPointerUp() {
    this.isDown = false;
    this.scroller.classList.remove('is-dragging');
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
    window.removeEventListener('pointercancel', this.onPointerUp);

    window.setTimeout(() => {
      this.dragged = false;
    }, 0);
  }

  onClick(event) {
    if (!this.dragged) return;
    event.preventDefault();
    event.stopPropagation();
  }
}

document.querySelectorAll('[data-template="index"] .collection-list, .product__media-list').forEach((list) => {
  new DragScroll(list);
});
